<template>
    <button class="btn__more" :class="{'is-loading': isLoading}">
        <!-- {{ text }} -->
        <span class="btn__more__spinner"></span>
    </button>
</template>

<script>
export default {
  name: 'app-button-more',

  props: {
      text: {
          type: String,
          required: true
      }
  },

  computed: {

  },

  data() {
    return {
        isLoading: false
    }
  },

  created()
  {
      
  },

  mounted() {
      // this.addEventListeners()
  },

  destroyed()
  {
      this.removeEventListeners()
  },

  methods: {
    addEventListeners()
    {
        this.observer = new IntersectionObserver(entries => {
            const button = entries[0]

            if (button.isIntersecting)
            {
                this.isLoading = true
                this.$parent.loadMore()
            }
        })

        this.observer.observe(this.$el)
    },

    removeEventListeners()
    {
        this.observer.disconnect()
    },
  }
}
</script>

<style lang="stylus">
.btn__more
    cursor pointer
    position relative
    width 100%
    height 115px
    display inline-block
    // border 1px solid #bebeba
    font-size 42px
    line-height 115px
    text-transform uppercase

    &.is-loading
        opacity 1
        // cursor wait

        &:before, &:after
            opacity 0
            visibility hidden

    @media(max-width 768px)
        width 100%
        height 60px
        font-size 26px
        line-height 60px

    &:before, &:after
        content ''
        position absolute
        display none
        top 50%
        right 12%
        height 1px
        width 30px
        background $black

        @media(max-width 768px)
            display none

    &:after
        transform rotate(90deg)

.btn__more__spinner
    position absolute
    top 50%
    left 50%
    display block
    width 35px
    height 35px
    border 4px solid rgba(13, 13, 22, 0.2)
    border-top-color $black
    border-radius 50%
    animation spinRotate .7s linear infinite
    transform translateY(-50%) translateX(-50%) rotate(0deg)
    opacity 0
    visibility hidden

    .is-loading &
        opacity 1
        visibility visible

    @media(max-width 768px)
        right 6%
        width 25px
        height 25px
        border 3px solid rgba(13, 13, 22, 0.2)
        border-top-color $black


@keyframes spinRotate {
    100% {
        transform translateY(-50%) translateX(-50%) rotate(360deg)
    }
}
</style>